const clientConfig = {
	siteUrl: process.env.REACT_APP_URL ? process.env.REACT_APP_URL : 'https://inceptsustain.loc/',
	nodesiteUrl: process.env.REACT_APP_API_NODE ? process.env.REACT_APP_API_NODE : 'https://notfound.incept/',
	//nodesiteUrl: 'http://localhost:8080/',
	nextUrl: process.env.REACT_APP_NEXT_APP_URL ? process.env.REACT_APP_NEXT_APP_URL : 'https://notfound.incept/',
	swedbankLoanLink: process.env.SWEDBANK_LOAN_LINK ?? "https://online.swedbank.se/app/ib/meddelanden/nytt",
	googleStorageSwedbankLoanPdfLink: process.env.SWEDBANK_LOAN_PDF_LINK ?? 'https://storage.googleapis.com/is-inceptbk-csb-eu-media-25cd/front-download/L%C3%A5neans%C3%B6kan.pdf'
};

export default clientConfig;
